import React, { useEffect, useState } from "react";
import {
  RadioGroup,
  Box,
  Button,
  Stack,
  Alert,
  AlertTitle,
} from "@mui/material";
import Checkbox from "../Base/Checkbox/index";
import SubmitButton from "../common/SubmitButton";
import Note from "../common/Note";
import configData from "../../Config";
import Backdrop from "../common/Backdrop";
import LoadingDots from "../Lottie/LoadingDots";
import { useNavigate, useLocation } from "react-router-dom";
import { apis } from "../../services/apiService";
import styles from "../../Style/Modules/gstNumber.module.css";
import "../../Style/Theme/index.css";

import useSelector from "../../store/selector";
import {
  constant,
  encryptData,
  loggerStore,
  multiDecryption,
} from "../../utils/utils";
import AlertPopup from "../common/AlertPopup";
const GstForm = () => {
  const navigate = useNavigate();
  let location = useLocation();
  const [disabled, setDisabled] = useState(true);
  const [GSTNo, setGST] = useState("");
  const [loading, setLoading] = useState(false);
  const { setRecoilVal, getRecoilVal } = useSelector();
  const [finalErr, setFinalErr] = useState("");
  const handleChange_New = (e) => {
    e.preventDefault();
    let data = {
      anchor: location.state.anchor,
      program: location.state.program,
      source: location.state.source,
      AppId: location.state.AppId,
      gstin: GSTNo,
    };
    navigate("/gst-number/gst_Detail", {
      state: data,
    });
  };

  const handleChange = (e) => {
    e.preventDefault();
    setGST(e?.target?.value.trim());
    setDisabled(false);
  };

  const results = [];
  location.state.gstins.split(",").forEach((g, index) => {
    results.push(
      <Box sx={{ display: "flex" }}>
        {/* <Box onClick={() => handleChange(g)} sx={{ width: "100%" }}> */}
        <Checkbox key={index} value={g} label={g} />
        {/* </Box> */}
      </Box>
    );
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    let getPreGstDatafromRecoil = getRecoilVal(constant.atomsName.GST_DETAILS);
    if (getPreGstDatafromRecoil !== null) {
      let decrypteddata = await multiDecryption(getPreGstDatafromRecoil);
      let selectedKey = Object.keys(decrypteddata);
      if (selectedKey.includes(GSTNo)) {
        let data = {
          anchor: location.state.anchor,
          program: location.state.program,
          source: location.state.source,
          AppId: location.state.AppId,
          gstin: GSTNo,
        };
        navigate("/gst-number/gst_Detail", {
          state: data,
        });
      } else {
        try {
          setLoading(true);
          const reqData = {
            aid: location.state.AppId,
            gst: GSTNo,
            show_details: true,
          };

          let resp = await apis.postApi(
            configData.API_URL + "GST/GSTDetailed",
            reqData
          );
          let result = await resp.json();
          if (resp?.status === 200) {
            setLoading(false);
            let respDatawithObj = result?.data;
            setRecoilVal(constant.atomsName.GST_DETAILS, {
              ...getPreGstDatafromRecoil,
              [GSTNo]: await encryptData(JSON.stringify(respDatawithObj)),
            });
            let data = {
              anchor: location.state.anchor,
              program: location.state.program,
              source: location.state.source,
              AppId: location.state.AppId,
              gstin: GSTNo,
            };
            navigate("/gst-number/gst_Detail", {
              state: data,
            });
          }
        } catch (error) {
          const errorResult = JSON.parse(error?.message);
          setLoading(false);
          setFinalErr(errorResult?.statusMessage);
          loggerStore(
            location?.state?.AppId,
            `showGST API response for failed only for check details= ${JSON.stringify(
              error
            )}`,
            "Information"
          );
        }
      }
    } else {
      try {
        setLoading(true);
        const reqData = {
          aid: location.state.AppId,
          gst: GSTNo,
          show_details: true,
        };

        let resp = await apis.postApi(
          configData.API_URL + "GST/GSTDetailed",
          reqData
        );
        let result = await resp.json();
        if (resp?.status === 200) {
          setLoading(false);
          let respDatawithObj = result?.data;
          setRecoilVal(constant.atomsName.GST_DETAILS, {
            [GSTNo]: await encryptData(JSON.stringify(respDatawithObj)),
          });
          let data = {
            anchor: location.state.anchor,
            program: location.state.program,
            source: location.state.source,
            AppId: location.state.AppId,
            gstin: GSTNo,
          };
          navigate("/gst-number/gst_Detail", {
            state: data,
          });
        }
      } catch (error) {
        const errorResult = JSON.parse(error?.message);
        setLoading(false);
        setFinalErr(errorResult?.statusMessage);
        loggerStore(
          location?.state?.AppId,
          `showGST API response for failed only for check details= ${JSON.stringify(
            error
          )}`,
          "Information"
        );
      }
    }
  };

  const handleClosedFunk = () => {
    setFinalErr("");
  };

  return (
    <Box
      component="form"
      noValidate
      id="GstForm"
      onSubmit={handleSubmit}
      // onSubmit={handleChange_New}
      autoComplete="off"
      sx={{ paddingBottom: "10px" }}
    >
      <Note note="Select your primary GST number to get highest eligibility" />
      <Box className={styles.gstNumberBox}>
        <RadioGroup name="gstNumber" onChange={handleChange}>
          {/*<Checkbox value="22NMJH9127461A1Z5" label="22NMJH9127461A1Z5" />*/}
          {results}
        </RadioGroup>
      </Box>
      {loading && (
        <Backdrop ax="center">
          <LoadingDots />
        </Backdrop>
      )}
      {finalErr && (
        <Backdrop ax="center">
          <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />;
        </Backdrop>
      )}
      <SubmitButton hasNote="No" disabled={disabled} />
    </Box>
  );
};

export default GstForm;
